import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import DashboardRepository, { BasicDashboardData } from "../../repositories/DashboardRepository";

interface _Props {
    dashboardRepository: DashboardRepository;
}

@injectable()
export default class GetBasicDashboardDataUseCase {
    private dashboardRepository: DashboardRepository;
    
    constructor(props: _Props) {
        this.dashboardRepository = props.dashboardRepository;
    }
    
    public call = async (): Promise<Either<ErrorEntity, BasicDashboardData>> => {
        return await this.dashboardRepository.getBasicData();
    }
}

export const GetBasicDashboardDataUseCaseName = "GetBasicDashboardDataUseCase";